import { MouseEvent } from 'react';
import { useDrawer } from '@components/Drawer';

export const useToggle = () => {
  const { open: openDrawer, toggleDrawer, closeDrawer } = useDrawer();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    //e.stopPropagation();
    e.preventDefault();

    toggleDrawer();
  };

  return {
    isOpen: openDrawer,
    handleClick,
    handleClose: closeDrawer,
  };
};
